<template>
    <section v-if="json" class="page-generic">
        <GenericText
            bgColor="bg-purple-dk"
            :json="json"
        ></GenericText>
    </section>
</template>
<script>
import axios from 'axios'
import GenericText from '@/components/blocks/GenericText'
import gh from '@/helpers/gh'
export default {
    name: "GenericPagePage",
    components: {
        GenericText,
    },
    data () {
        return {
            window: window,
            json: null,
            transition: false,
        }

    },
    created () {
    },
    mounted () {
        let slug = this.$route.name === 'page-not-found'
            ? 'page-not-found'
            : this.$route.fullPath
        slug = gh.stripSlashesFrontAndBack(slug)
        axios.get((`${window.config.apiroot}${slug}/${window.config.craftApiPreviewToken}`))
            .then((res) => {
                this.json = res.data
                this.reveal()
            }).catch((e) => {
                console.error('Error',slug,e)
                // Fallback: if we weren't already on page-not-found, try fetching it
                if (slug !== 'page-not-found') {
                    axios.get((`${window.config.apiroot}page-not-found/${window.config.craftApiPreviewToken}`))
                        .then((res) => {
                            this.json = res.data
                            this.reveal()
                        }).catch((err) => {
                            console.error('Error', 'page-not-found', err)
                        })
                }
        })
    },
    methods: {
        reveal () {

        },
        unreveal () {

        },
    }
}
</script>
